'use client';

import { usePathname } from 'next/navigation';
import { Button } from '@/components/button';

export type Tab = {
  label: string;
  path: string;
};

type TabsProps = {
  tabs: Tab[];
};

export const Tabs = ({ tabs }: TabsProps) => {
  const pathname = usePathname();

  if (tabs.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 items-center gap-4 rounded-lg bg-dark-gray px-4 py-3 sm:grid-cols-2 md:flex md:gap-5">
      {tabs.map(({ label, path }) => {
        const isActive = pathname === path;

        return (
          <Button
            as="link"
            href={path}
            key={path}
            variant={isActive ? 'secondary' : 'ghost'}
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
};
